const colours = {
    primary: {
        blue: '#265BFF',
        medBlue: '#92ACFF',
        lightblue: '#E8EFFF',
        white: '#FFFFFF',
        black: 'rgba(33, 43, 54, 1)',
        grey01: '#454F5B',
        grey02: '#919EAB',
        grey03: '#C4CDD5',
        grey04: '#DFE3E8',
        grey05: '#F4F6F8'
    },
    accent: {
        validate_green: '#2EB996',
        error_red: '#EF5455',
        caution_yellow: '#FFCD0E',
        bright_yellow: '#FFFF00',
        light_green: '#C1EAE0',
        light_yellow: '#FFF0B7'
    },
    functional: {
        overlay: 'rgba(69, 79, 91, 0.7)',
        pool_fleet: 'rgba(58, 143, 240, 1)',
        pool_press: 'rgba(255, 255, 255, 1)',
        pool_general: 'rgba(255, 255, 255, 1)',
        pool_marketing: 'rgba(10, 199, 158, 1)',
        pool_testing: 'rgba(50, 165, 53, 1)',
        pool_company: 'rgba(189, 25, 126, 1)',
        division_toronto: 'rgba(40, 190, 136, 1)',
        division_montreal: 'rgba(82, 215, 233, 1)',
        division_vancouver: 'rgba(129, 108, 255, 1)',
        hover_primaryblue: 'rgba(75, 153, 243, 1)',
        hover_secondaryblue: 'rgba(233, 243, 254, 1)',
        hover_primaryred: 'rgba(242, 118, 119, 1)',
        hover_secondaryred: 'rgba(254, 238, 238, 1)',
        hover_primarygreen: 'rgba(88, 199, 171, 1)',
        hover_secondarygreen: 'rgba(224, 245, 239, 1)'
    }
}

export default colours;